/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const jobStyles = {
  background: {
    backgroundColor: "background.contrast",
  },
  container: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  list: {
    marginBottom: "0.5rem",
    paddingInlineStart: "1.5rem",
    "& li": {
      paddingBottom: "1rem",
    },
  },
  text: {
    marginBottom: "1.5rem",
  },
};

export default jobStyles;
